import { Component, OnInit, Inject, Input, OnChanges } from '@angular/core';
import { Router } from '@angular/router';

// Angular Fire
import { FirebaseApp } from 'angularfire2';
import { AngularFireAuth } from 'angularfire2/auth';
import { Observable } from 'rxjs/Observable';
import { UsuariosPersonalService } from '../../../services/usuarios-personal.service';
import { ViajesService } from './../../../services/viajes.service';
import { UnidadesService } from './../../../services/unidades.service';
@Component({
  selector: 'unidades-disponibles',
  templateUrl: './unidades-disponibles.component.html'
})

export class UnidadesDisponiblesComponent implements OnInit, OnChanges {
	// Propiedades de la clase
	currentUser:any; // usuario que hizo login
    @Input() fechaInicio:any;
    @Input() fechaFin:any;
    unidadesOcupadas:Observable<any>;
    unidades:Observable<any>;
    unidadesAuto:Array<any>=[];
    unidadesTipo1:Array<any>=[];
    unidadesTipo2:Array<any>=[];
    unidadesLujo:Array<any>=[];
    totalAuto:number=0;
    totalTipo1:number=0;
    totalTipo2:number=0;
    totalLujo:number=0;
	constructor(
		private afAuth:AngularFireAuth, 
        private usuariosService: UsuariosPersonalService,
        private viajesService: ViajesService,
        private unidadesService:UnidadesService
    ){

	}

	ngOnInit(){
        this.currentUser = this.usuariosService.auth;
		
    }
    ngOnChanges(){
        //Se verifica que ambas fechas no sean indefinidas
        if(!isNaN(this.fechaFin) && !isNaN(this.fechaInicio) && this.fechaFin != null && this.fechaInicio != null && this.fechaFin != undefined && this.fechaInicio != undefined) {
            //Se obtienen unidades que no esten ocupadas en viajes dentro de ambas fechas
            this.unidadesOcupadas= this.viajesService.obtenerUnidadesNoDisponibles(this.fechaInicio,this.fechaFin);
            //Se obtienen todas las unidades de la BD
            this.unidades= this.unidadesService.obtenerUnidades().snapshotChanges().map( unidadesDB=> {
                let lista=[]
                this.totalAuto=0;
                this.totalTipo1=0;
                this.totalTipo2=0;
                this.totalLujo=0;
                //Se realiza el proceso para poder tener la $key dentro del objeto de unidad
                unidadesDB.forEach((actions)=>{
                    const data = actions.payload.doc.data();
                    const $key = actions.payload.doc.id;
                    //Dependiendo de el tipo de unidad se va sumando el contador de cada tipo
                    switch (data.tipoDeUnidad) {
                        case 'Auto':
                            this.totalAuto++
                            break;
                        case 'Tipo 1':
                            this.totalTipo1++
                            break;
                        case 'Tipo 2':
                            this.totalTipo2++
                            break;
                        case 'Lujo':
                            this.totalLujo++
                            break;
                        default:
                            break;
                    }
                        lista.push({ $key,...data  })
                })
            return lista
            })
            Observable.zip(
                this.unidades,
                this.unidadesOcupadas
            ).subscribe(arregloUnidades=>{

                //Se quitan de la lista total las unidades que esten ocupadas
                let arregloCompleto:Array<any>=arregloUnidades[0]
                let arregloOcupadas=arregloUnidades[1]
                arregloOcupadas.forEach((unidad)=>{
                    arregloCompleto = arregloCompleto.filter(function( obj ) {
                        return obj.$key !== unidad.$key;
                    });
                })
                //Se implementa un metodo que separa  las unidades Disponibles  por tipo de unidad
                this.rellenarArreglosDeUnidades(arregloCompleto)
            })
        }

    }
    rellenarArreglosDeUnidades(arregloCompleto){
        this.unidadesAuto=[];
        this.unidadesTipo1=[];
        this.unidadesTipo2=[];
        this.unidadesLujo=[];
        arregloCompleto.forEach(unidadesCompletas => {
            /*
            Cuando se comparan ambos arreglos se valida que  unidades ya ha sido
            ocupadas y  que tipo son, para asi almancenarlas en sus respectivos arreglos
            */
            if(unidadesCompletas.tipoDeUnidad == 'Auto' && !(this.unidadesAuto.includes(unidadesCompletas))) 
                    this.unidadesAuto.push(unidadesCompletas)
            else if(unidadesCompletas.tipoDeUnidad == 'Tipo 1' && !(this.unidadesTipo1.includes(unidadesCompletas))) 
                this.unidadesTipo1.push(unidadesCompletas)
            else if(unidadesCompletas.tipoDeUnidad == 'Tipo 2' && !(this.unidadesTipo2.includes(unidadesCompletas))) 
                this.unidadesTipo2.push(unidadesCompletas)
            else if(unidadesCompletas.tipoDeUnidad == 'Lujo' && !(this.unidadesLujo.includes(unidadesCompletas))) 
                this.unidadesLujo.push(unidadesCompletas)
        });
    }

	
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/components/unidades-disponibles/unidades-disponibles.component.ts